var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgUmbrella = props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 354.04 354.04"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 38",
  d: "M187.392 177.02v135.528a39.934 39.934 0 01-10.372 27.176 40.987 40.987 0 01-31.117 14.313 41.611 41.611 0 01-41.489-41.489v-10.369a10.373 10.373 0 0120.745 0v10.369a20.745 20.745 0 1041.489 0V177.02a10.373 10.373 0 1120.745 0zm0 0",
  fill: "#68544f"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 39",
  d: "M187.392 177.02v135.528a39.933 39.933 0 01-10.372 27.179V166.648a10.269 10.269 0 0110.372 10.372zm0 0",
  fill: "#53433f"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 40",
  d: "M187.393 52.553v82.978a10.373 10.373 0 01-20.745 0V52.553a10.373 10.373 0 0120.745 0zm0 0",
  fill: "#68544f"
})), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 41",
  d: "M187.392 52.553v82.978a10.271 10.271 0 01-10.372 10.373V42.181a10.269 10.269 0 0110.372 10.372zm0 0",
  fill: "#53433f"
})), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 42",
  d: "M177.02 62.925C79.729 62.925 0 123.497 0 197.764v10.372a10.271 10.271 0 0010.372 10.372 10.271 10.271 0 0010.372-10.372c0-11.2 15-20.745 31.808-20.745s31.118 9.544 31.118 20.746a10.373 10.373 0 0020.745 0c0-11.2 14.313-20.745 31.117-20.745s31.117 9.543 31.117 20.745a10.373 10.373 0 0020.745 0c0-11.2 14.313-20.745 31.117-20.745s31.117 9.543 31.117 20.745a10.373 10.373 0 1020.745 0c0-11.2 14.313-20.745 31.117-20.745s31.81 9.543 31.81 20.745a10.373 10.373 0 1020.745 0v-10.373c-.005-74.267-79.734-134.839-177.025-134.839zm0 0",
  fill: "#cea8fa"
})), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 43",
  d: "M354.04 197.764v10.372a10.373 10.373 0 11-20.745 0c0-11.2-15-20.745-31.808-20.745s-31.117 9.543-31.117 20.745a10.373 10.373 0 11-20.745 0c0-11.2-14.313-20.745-31.117-20.745s-31.117 9.543-31.117 20.745a10.271 10.271 0 01-10.371 10.373V62.925c97.291 0 177.02 60.572 177.02 134.839zm0 0",
  fill: "#bf8ef9"
})), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 44",
  d: "M252.529 145.279a10.816 10.816 0 01-3.733.624 10.036 10.036 0 01-9.543-6.639c-13.276-34.228-37.132-55.594-62.234-55.594s-48.958 21.366-62.234 55.594a10.269 10.269 0 01-13.276 6.015 10.418 10.418 0 01-6.015-13.481c16.389-42.529 47.505-68.873 81.526-68.873s65.137 26.344 81.525 68.873a10.418 10.418 0 01-6.016 13.481zm0 0",
  fill: "#bf8ef9"
})), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 45",
  d: "M135.531 42.181a10.368 10.368 0 01-10.372-10.373V10.372a10.373 10.373 0 0120.745 0v21.436a10.368 10.368 0 01-10.373 10.373zm0 0",
  fill: "#ede9e8"
})), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 46",
  d: "M218.509 42.181a10.368 10.368 0 01-10.372-10.373V10.372a10.373 10.373 0 0120.745 0v21.436a10.368 10.368 0 01-10.373 10.373zm0 0",
  fill: "#dfd7d5"
})), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 47",
  d: "M280.742 62.925a10.368 10.368 0 01-10.372-10.372V31.808a10.373 10.373 0 1120.745 0v20.745a10.368 10.368 0 01-10.373 10.372zm0 0",
  fill: "#dfd7d5"
})), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 48",
  d: "M73.297 62.925a10.368 10.368 0 01-10.372-10.372V31.808a10.373 10.373 0 1120.745 0v20.745a10.368 10.368 0 01-10.373 10.372zm0 0",
  fill: "#ede9e8"
})), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
  "data-name": "Path 49",
  d: "M252.53 145.279a10.816 10.816 0 01-3.733.624 10.036 10.036 0 01-9.543-6.639C225.978 105.035 202.12 83.67 177.02 83.67V62.925c34.021 0 65.137 26.344 81.525 68.873a10.418 10.418 0 01-6.015 13.481zm0 0",
  fill: "#ad6cf8"
})));
export default SvgUmbrella;